import { render } from "./mg-about.vue?vue&type=template&id=691ef6be&scoped=true"
const script = {}

import "./mg-about.vue?vue&type=style&index=0&id=691ef6be&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691ef6be"]])

export default __exports__